// Kickers and the centered page head (DESIGN_SPEC §10.2).
//   <Kicker dash? as? className?>Analysis <Kid>9f3c…</Kid><Sep />completed</Kicker>   spaced mono CAPS; dash = 18px accent rule first
//   <Kid>…</Kid>      an identifier inside a kicker: keeps its case, faint, select-all
//   <Sep />           the faint "·" separator (aria-hidden)
//   <PageHead kicker title lede? meta? />   Conifer's centered /models head (Analyses, Nodes)
import type { ReactNode } from "react";
import { cx } from "./cx";

export function Kicker({ dash, as: Tag = "p", className, children }: { dash?: boolean; as?: "p" | "div" | "span"; className?: string; children: ReactNode }) {
  return <Tag className={cx("kicker", dash && "kicker--dash", className)}>{children}</Tag>;
}

export function Kid({ children }: { children: ReactNode }) {
  return (
    <span className="kid" translate="no">
      {children}
    </span>
  );
}

export function Sep({ className }: { className?: string }) {
  return (
    <span className={cx("sep", className)} aria-hidden="true">
      ·
    </span>
  );
}

export function PageHead({ kicker, title, lede, meta }: { kicker: ReactNode; title: ReactNode; lede?: ReactNode; meta?: ReactNode }) {
  return (
    <header className="page-head">
      <Kicker>{kicker}</Kicker>
      <h1 className="page-title">{title}</h1>
      {lede && <p className="page-lede">{lede}</p>}
      {meta && <p className="meta mt-3">{meta}</p>}
    </header>
  );
}
